import type { GetAssessmentAuditByIdResponseRow } from '@risksmart-app/drizzle/src/types';
import { GetAssessmentAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

import type { AuditLogQueryResult } from './auditLogQueryResult';

type UseGetAssessmentAuditByIdArgs = {
  id: string;
};

export const useGetAssessmentAuditById = createQueryHook<
  UseGetAssessmentAuditByIdArgs,
  GetAssessmentAuditByIdResponseRow[],
  AuditLogQueryResult<
    'assessment_audit',
    GetAssessmentAuditByIdResponseRow,
    'Summary'
  >
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getAssessmentAuditById.queryOptions({
      id,
    }),
  mapTrpcDataToGraphQL: (data) => ({ assessment_audit: data }),
  graphqlDocument: GetAssessmentAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
